var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currency==1)?_c('img',{attrs:{"src":_vm.$store.state.webConfig.price_ico}}):_c('span',[_vm._v("¥")])}
var staticRenderFns = []

export { render, staticRenderFns }